// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"447":"782a66c4","453":"eea1982c","967":"974fd7f1"}[chunkId] + ".chunk.js";
};